export enum StableLinksWorkspaceCapabilityAccessOperation {
    create = "c59ed9b2-f27f-4e4b-8cb9-97bfbb5360ce",
    read = "7799c1c9-e1e7-4f51-8c06-b2524edb93ff",
    update = "9d1b5814-0420-4902-a11d-44724577c58c",
    delete = "342907b6-5464-4064-901e-08562ab9e2a8",
}
